module.exports = __webpack_public_path__ + "img/hand-holding-droplet.ed95f462.svg";